import { forwardRef } from "react";

/* -----------------Types--------------- */
import type { SessionItem } from "@memorang/types/src/session/new-session";
/* -----------------UI--------------- */
import type { FlashList } from "@shopify/flash-list";

import Box from "@memorang/ui/src/components/Box";
/* -----------------Child components--------------- */
import SessionListDesktop from "./SessionListDesktop";

interface Props {
	items: SessionItem[];
	toggleShowReadMore: () => void;
}

const SessionList = forwardRef<FlashList<SessionItem>, Props>(
	({ items, toggleShowReadMore }) => {
		return (
			<Box gap={16} flexGrow={1} alignItems="center" height="100%">
				<SessionListDesktop
					items={items}
					toggleShowReadMore={toggleShowReadMore}
				/>
			</Box>
		);
	},
);
export default SessionList;
